import { gql } from '@apollo/client';

export const CREATE_STAND_IN = gql`
    mutation CreateStandIn($input: CreateStandInInput!) {
        createStandIn(createStandInInput: $input) {
            successful
        }
    }
`;

export const UPDATE_STAND_IN = gql`
    mutation UpdateStandIn($input: UpdateStandInInput!) {
        updateStandIn(updateStandInInput: $input) {
            successful
        }
    }
`;

export const DELETE_STAND_IN = gql`
    mutation DeleteStandIn($id: String!) {
        deleteStandIn(id: $id) {
            successful
        }
    }
`;
